import { render, staticRenderFns } from "./checkUpPlan.vue?vue&type=template&id=38ba98a6"
import script from "./checkUpPlan.vue?vue&type=script&lang=js"
export * from "./checkUpPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ba98a6')) {
      api.createRecord('38ba98a6', component.options)
    } else {
      api.reload('38ba98a6', component.options)
    }
    module.hot.accept("./checkUpPlan.vue?vue&type=template&id=38ba98a6", function () {
      api.rerender('38ba98a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpPlan.vue"
export default component.exports